"use strict";

 (function (global) {

   var cssClass = "sidebar_item";

 
     /**
    * Класс-обертка для коллекции закладок
    * @class WebAccess.components.wrappers.sideBar.Tabs
    * @extends WebAccess.Collecton
    * @since 5.2.0.1600  
    */
    var _ExplorerTabs = global.components.wrappers.sideBar.Tabs.extend({

      _tabSelector: 'div.explorer-search-panel__item',
      _byNameSelectorTemplate: '{0}[name="{1}"]',

    
      /**
      * Новые кнопки тоже должны уметь делать expand/collapse
      * @private
      */
      _defaultClickHandler: function (element, name, currentTabSelector) {
        var me = this;
        // обработка двойного клика - сворачивание - разворачивание. 
        var index = $(me._tabSelector).index(element);

        if (window.nowSelect == index) {
          if (!me._current.sideBar.isCollapsed()) me._current.sideBar.collapse();
          else me._current.sideBar.expand();
        }
        else {
          window.nowSelect = index;
          me._current.sideBar.expand();
        }
        if (name !== "FldTree" && name !== "Run") CustomSearch(name, this);        
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
      * Проверить наличие закладки боковой панели.
      * 
      * @method WebAccess.components.wrappers.sideBar.Tabs#isExist
      * @param tabName Имя закладки
      * @return {boolean} True, если закладка существует, иначе False.
      */
      isExist: function (tabName) {
        var me = this;

        var selector = format(byNameSelectorTemplate, me._tabSelector, tabName);
        me._jExistingTab = me._jSideBarConatainer.find(selector);
        return me._jExistingTab.length > 0;
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      
      /**
      * Создать новую закладку боковой панели.
      **/
      // TODO: Возможность создавать закладки временно отключена.
      create: function (tabName) { return; }

    });

    global.components.wrappers.sideBar._ExplorerTabs = _ExplorerTabs;

})(window.WebAccess);